// Required Field Validator
import {ValidatorResult} from "@/shared/models/form/fields/types";
import {BaseValidator} from "@/shared/models/form/fields/validators/validator.interface";

export class RequiredValidator extends BaseValidator {
    constructor(message: string = "required") {
        super(message);
    }

    validate(value: string): ValidatorResult {
        const trimmed = value?.trim() || "";
        return trimmed.length > 0 ? this.success() : this.fail();
    }
}
